import React from "react";
import { Link } from "react-router-dom";
import { route } from "../../../../shim/jsbridge";

type Props = {
  predictedFileName?: string;
};

const PredictedFileNameLink = ({ predictedFileName }: Props) => {
  if (!predictedFileName) {
    return null;
  }

  return (
    <Link
      to={route("search", [], {
        q: `filename:"${predictedFileName.replaceAll('"', '\\"')}"`
      })}
      onClick={e => {
        e.stopPropagation();
      }}
      title="Search for samples with the same name"
      className="samples-grid__predicted-filename"
    >
      {predictedFileName}
    </Link>
  );
};

export default PredictedFileNameLink;
